<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import BaseBtn, { type BaseBtnProps } from '@/ui/base/BaseBtn.svelte';
  import Icon, { type IconName } from '@/ui/base/icon/Icon.svelte';

  export type BrandFitStyle = 'notAnalyzed' | 'pass' | 'fail';

  export interface BrandFitProps {
    style: BrandFitStyle;
    onclick: BaseBtnProps['onclick'];
    loading?: boolean;
  }
</script>

<script lang="ts">
  let { style: styleProp, loading, ...props }: BrandFitProps = $props();

  // Styles for button
  const btnStyle = tv({
    base: 'flex items-center gap-1 rounded-sm p-1 font-sans text-xs font-regular',
    variants: {
      style: {
        notAnalyzed: 'bg-brandfit text-c-light',
        pass: 'bg-brandfit-success text-c',
        fail: 'bg-brandfit-error text-c',
      },
    },
  });

  let icon: IconName | undefined = $derived(
    styleProp === 'pass' ? 'CheckCircleOutline'
    : styleProp === 'fail' ? 'WarningAmber'
    : undefined,
  );
</script>

<BaseBtn class={btnStyle({ style: styleProp })} {...props} disabled={!props.onclick}>
  BRAND FIT
  {#if loading}
    <Icon icon="Loading" size={3} class="mx-auto" />
  {:else if icon != undefined}
    <Icon class="size-4" {icon}></Icon>
  {/if}
</BaseBtn>
